import { BookingPresenter } from '@shared/modules/bookings/booking.presenter';
import { CarerPresenter } from '@shared/modules/carers/carer.presenter';
import {
    ClientTaskCompletionPresenter
} from '@shared/modules/client-task-completions/client-task-completion.presenter';
import {
    ClientTaskScheduleEntryPresenter
} from '@shared/modules/client-task-schedule-entries/client-task-schedule-entry.presenter';
import { ClientPresenter } from '@shared/modules/clients/client.presenter';
import type { PotentialCarer, ReconcilableTask } from '@shared/modules/tasks/reconcilable-task';
import { Presenter } from '@shared/presenters/presenter';
import type { DateTime } from 'luxon';

export class ReconcilableTaskPresenter extends Presenter<ReconcilableTask> {
    get isBeforeNow(): boolean {
        const now = new Date();

        return this._get(`isBeforeNow:${now.setSeconds(0, 0).valueOf()}`, () => this.start.toJSDate() < now);
    }

    get client(): ClientPresenter {
        return this.present('client.data', ClientPresenter);
    }

    get task(): ClientTaskScheduleEntryPresenter {
        return this.present('task.data', ClientTaskScheduleEntryPresenter);
    }

    get completion(): ClientTaskCompletionPresenter {
        return this.present('completion.data', ClientTaskCompletionPresenter);
    }

    get date(): DateTime {
        return this._get('date', () => this.formatDate(this.toDateTime('date')));
    }

    get start(): DateTime {
        return this.toDateTime('start');
    }

    get times() {
        return this._get('times', () => `${this.task.start} - ${this.task.finish}`);
    }

    get actualTimeRange() {
        return this._get('actualTimeRange', () => {
            const start = this.toDateTime('start');

            return this.formatDateTimeRange(
                start,
                start.plus({ seconds: this.data.task.data.duration })
            );
        });
    }

    get potentialCarers(): { carer: CarerPresenter; booking: BookingPresenter; value: PotentialCarer }[] {
        return this._get('potentialCarers', () => (this.get('potential_carers.data', []) as PotentialCarer[]).map(p => {
                console.log({ p });

                return ({
                    value: p,
                    carer: CarerPresenter.create(p.carer.data),
                    booking: BookingPresenter.create(p.booking.data)
                });
            }));
    }

}
